import { GroupsCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function GroupFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <GroupsCommandList multiselect selected={selection} onSelect={onSelect} />
}
